import { t } from '@lingui/core/macro';
import { useMutation } from '@tanstack/react-query';

import { participantProjectsControllerResendPayoutEmail } from '@/api/core-api';
import { notify } from '@/components/base/notifications/notifications';
import { getClient } from '@/utils/get-api-client';

export function useResendPayoutEmail() {
  return useMutation({
    mutationFn: async ({
      projectId,
      userId,
    }: {
      projectId: string;
      userId: string;
    }) => {
      const client = getClient(userId);
      const response = await participantProjectsControllerResendPayoutEmail({
        path: { projectId },
        client,
      });

      if (response.error) {
        throw new Error('Failed to cancel application');
      }

      return { projectId, userId };
    },
    onSuccess: () => {
      notify({
        title: t`Email sent`,
        color: 'success',
      });
    },
    onError: (error) => {
      notify({
        title: t`Failed to send email`,
        description: error.message,
        color: 'error',
      });
    },
  });
}
